import React from "react";
import NotaRural from "../images/notarural.png";
import ActividadRural from "../images/actividadrural.png";

import Campo from "../images/campo.png";
import Ciudad from "../images/ciudad.png";

import FondoMuni from "../images/fondomuni.png";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  actividadFondo: {
    backgroundImage: "url(" + FondoMuni + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    minHeight: 500,
    width: "100%",
    marginTop: 40,
    textAlign: "right",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    "& p": {
      lineHeight: 1.5,
      maxWidth: 400,
    },
    marginBottom: "4em",
  },
  actividad: {
    background: "#6a2c9138",
    border: "6px solid " + theme.palette.purple.main,
    "& p": {
      marginLeft: "1em",
    },
    marginBottom: "4em",
  },
  options: {
    borderBottom: "1px solid #ccc",
  },
  option: {
    color: theme.palette.blue.main,
    textAlign: "right",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      marginBottom: "1em",
    },
  },
  actividadContent: {
    maxWidth: 800,
  },
}));

const Lamina2 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 7: El campo y ciudad"
        meta={[
          {
            property: "og:title",
            content: "Lámina 7: El campo y ciudad",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Los peruanos vivimos en distintos tipos de espacios. Algunos lo hacemos en el campo, conocido también como zona rural, y otros en la ciudad o zona urbana.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="7" color="primary" />
      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="EL CAMPO Y LA CIUDAD" color="primary" />
        <p>
          Los peruanos vivimos en distintos tipos de espacios. Algunos lo
          hacemos en el campo, conocido también como zona rural, y otros en la
          ciudad o zona urbana.
        </p>
        <Actividad color="primary" />
        <p>
          <strong>
            Observa las imágenes. Luego, lee las frases de abajo y encierra en
            un círculo la opción correcta.
          </strong>
        </p>
        <img src={Campo} alt="Campo" />
        <img src={Ciudad} alt="Ciudad" />
        <div className={classes.actividadContent}>
          <Grid container alignItems="center" className={classes.options}>
            <Grid item lg={8} md={8} sm={8} xs={12}>
              <ul>
                <li>
                  Es un espacio en el que se suelen realizar
                  actividadesagrícolas.
                </li>
              </ul>
            </Grid>
            <Grid item lg={4} md={4} sm={4} xs={12} className={classes.option}>
              CAMPO | CIUDAD
            </Grid>
          </Grid>
          <Grid container alignItems="center" className={classes.options}>
            <Grid item lg={8} md={8} sm={8} xs={12}>
              <ul>
                <li>
                  Podemos encontrar edificios, grandes avenidas, mercados,
                  centros comerciales y fábricas.
                </li>
              </ul>
            </Grid>
            <Grid item lg={4} md={4} sm={4} xs={12} className={classes.option}>
              CAMPO | CIUDAD
            </Grid>
          </Grid>
          <Grid container alignItems="center" className={classes.options}>
            <Grid item lg={8} md={8} sm={8} xs={12}>
              <ul>
                <li>Concentra muchos habitantes.</li>
              </ul>
            </Grid>
            <Grid item lg={4} md={4} sm={4} xs={12} className={classes.option}>
              CAMPO | CIUDAD
            </Grid>
          </Grid>
          <Grid container alignItems="center" className={classes.options}>
            <Grid item lg={8} md={8} sm={8} xs={12}>
              <ul>
                <li>Presenta un flujo reducido de vehículos.</li>
              </ul>
            </Grid>
            <Grid item lg={4} md={4} sm={4} xs={12} className={classes.option}>
              CAMPO | CIUDAD
            </Grid>
          </Grid>
        </div>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={2}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} xs={12}>
            <TitleSmall title=" LA VIDA EN LAS ZONAS RURALES" color="primary" />
            <p>
              Las zonas rurales son espacios de conservación de ambientes sanos,
              de buenas relaciones personales, de productos orgánicos y de
              turismo ecológico. Sin embargo, en ellas la población aún necesita
              contar con servicios que mejoren su calidad de vida, como agua
              potable, desagüe, electricidad y transporte, que les permitan un
              mayor desarrollo. Para satisfacer estas necesidades, deben
              intervenir las autoridades.
            </p>
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <img src={NotaRural} alt="Nota" />
          </Grid>
        </Grid>
        <Actividad color="primary" />
        <p>
          <strong>
            A continuación, se presentan tres actividades comunes de las zonas
            rurales. Une con una línea cada imagen al texto que mejor la
            describa.
          </strong>
        </p>
        <img src={ActividadRural} alt="actividad" />
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/06/Ciudadanía-Activa-Lámina-7.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          color="primary"
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 7: El campo y ciudad'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Perú, un territorio muy diverso"
        anteriorEnlace="/lamina-1-6"
        siguiente="La dinámica de la ciudad"
        siguienteEnlace="/lamina-1-8"
      />
    </>
  );
};

export default Lamina2;
